
import './Contact.css'
import { Link } from 'react-router-dom';
import a from '../assets/icons/facebook.png'
import b from '../assets/icons/github.png'
import c from '../assets/icons/instagram.png'
import d from '../assets/icons/linkedin.png'
import e from '../assets/icons/orcid.png'
import f from '../assets/icons/twitter1.png'
import g from '../assets/icons/whatsapp.png'
import h from '../assets/icons/telegram.png'
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

const Contact = () => {

    const { register, handleSubmit, formState: { errors } } = useForm();
    const currentDate = new Date();
    const currentTime = currentDate.toLocaleTimeString();

    const handleAddMessage = data => {
        const certificateData = {
            name: data.name,
            email: data.email,
            message: data.message,
            time: currentTime,
            date: currentDate.toISOString().split('T')[0],
        };

        fetch('https://saha-reno-portfolio-backend.onrender.com/message', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
            },
            body: JSON.stringify(certificateData)
        })
            .then(res => res.json())
            .then(result => {
                console.log(result);
                Swal.fire({
                    icon: 'success',
                    title: 'Message sent successfully',
                    showConfirmButton: false,
                    timer: 1500,
                }).then(() => {
                    window.location.reload();
                });
            })
            .catch(error => {
                console.error('Error adding Message:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error adding Message',
                });
            });
    };


    return (
        <div className='contact-body'>
            <div className='signboard3   p-5'>
                <div className='contact-container bg-slate-400'>
                    <p className='contact-info flick'>Contact Info</p>
                    <p>📞 +880 1706364326</p>
                    <p>📧 reno.saha39@gmail.com (Personal)</p>
                    <p>📧 saha.reno@baiust.edu.bd (Office)</p>
                    <Link><p>🔗 https://saha-reno.web.app</p></Link>
                    <p>🏠 Cumilla 3500, Bangladesh</p>
                </div>
            </div>


            <section className='main-is'>

                <div className='i-s'>
                    <div className='all-icon-container'>
                        <div className='item-n'><Link target='_blank' to='https://www.facebook.com/SahaReno'><img className='z1' src={a} alt="" /></Link> </div>
                        <div className='item-n'><Link><img target='_blank' className='z2' src={b} alt="" /></Link></div>
                        <div className='item-n'><Link target='_blank' to='https://api.whatsapp.com/send?phone=8801706364326'><div className='ax'><img className='z3' src={g} alt="" /></div></Link></div>
                        <div className='item-n'><Link target='_blank' to='https://www.linkedin.com/in/sahareno/'><img className='z4' src={d} alt="" /></Link></div>
                    </div>
                </div>

                <div className='i-s'>
                    <div className='all-icon-container'>
                        <div className='item-n'><Link><img target='_blank' className='z1' src={c} alt="" /></Link></div>
                        <div className='item-n'><Link target='_blank' to='https://t.me/SahaReno'><img className='z2' src={h} alt="" /></Link></div>
                        <div className='item-n'><Link target='_blank' to='https://twitter.com/SahaReno'><img className='z3' src={f} alt="" /></Link></div>
                        <div className='item-n'><Link target='_blank' to='https://orcid.org/0000-0003-1897-9002'><img className='z4' src={e} alt="" /></Link></div>
                    </div>
                </div>

            </section>


            {/* Email Section */}
            <div className='mt-24 shadow-slate-400 shadow-2xl'>
                <h1 className='text-center text-2xl font-bold'><u>Send a message for Saha Reno</u></h1>
                <section className='mail-section '>
                    <form onSubmit={handleSubmit(handleAddMessage)}>
                        <div className="form-control w-96 max-w-xs">
                            <label className="label"> <span className="label-text"><b>Your Name</b></span></label>
                            <input type="text" {...register("name", {
                                required: "Name is Required"
                            })} className="input  border-2 border-black w-full max-w-xs" />
                            {errors.name && <p className='text-red-500'>{errors.name.message}</p>}
                        </div>
                        <div className="form-control w-96 max-w-xs">
                            <label className="label"> <span className="label-text"><b>Your Email</b></span></label>
                            <input type="email" {...register("email", {
                                required: "Email is Required"
                            })} className="input  border-2 border-black w-full max-w-xs" />
                            {errors.email && <p className='text-red-500'>{errors.email.message}</p>}
                        </div>
                        <div className="form-control w-96 max-w-xs">
                            <label className="label"> <span className="label-text"><b>Write Message</b></span></label>
                            <input type="text" {...register("message", {
                                required: "Message is Required"
                            })} className="input  border-2 border-black w-full max-w-xs" />
                            {errors.message && <p className='text-red-500'>{errors.message.message}</p>}
                        </div>
                        <input onClick={toast} className='btn btn-accent w-full mt-4 mb-10' value="SEND" type="submit" />
                    </form>
                </section>
            </div>
        </div>
    );
};

export default Contact;